export default __webpack_public_path__ + "images/W2.2882a26.png";